import React, { useState, useEffect } from 'react';
import { flowExecutor } from '../api/be-connector.js';
import { PageManager } from './PageManager.js';
import { useAppDispatch, useAppSelector } from '../hooks/hooks.js';
import { selectSseConnectionOpen } from '../store/reducers/applicationSlice.js';
import { selectIsUnauthorizedToAccessApp } from '../store/reducers/authSlice.js';
import { setFlows, setSubscribedVariables } from '../store/reducers/flowSlice.js';
import { setVariables } from '../store/reducers/variablesSlice.js';

const AppManager = ({ pages, flows, variables, watchList }) => {
    const dispatch = useAppDispatch();
    const [flowsLoaded, setFlowsLoaded] = useState(false);
    const isUnauthorizedToAccessApp = useAppSelector(selectIsUnauthorizedToAccessApp);
    const sseConnectionOpen = useAppSelector(selectSseConnectionOpen);
    useEffect(() => {
        if (sseConnectionOpen) {
            flowExecutor.setFlowManifest(flows);
            // TODO: Find a way to remove slice from store
            dispatch(setFlows(flows));
            dispatch(setSubscribedVariables(watchList));
            setFlowsLoaded(true);
        }
    }, [flows, sseConnectionOpen]);
    useEffect(() => {
        dispatch(setVariables(variables));
    }, []);
    if (isUnauthorizedToAccessApp) {
        return (React.createElement("div", null, "You don't have permission to view this app in preview mode. Please contact the app owner."));
    }
    return flowsLoaded && pages ? (React.createElement(PageManager, { key: "page-manager", pages: pages })) : (React.createElement("span", null, "Loading"));
};

export { AppManager };
//# sourceMappingURL=AppManager.js.map
